import * as constants from "./constants";

export const capitalize = s => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const captureClick = e => {
  e.stopPropagation();
};

export const firstWithChild = items => {
  return items.filter(item => hasChildren(item))[0];
};

export function getCanShowDeadLinks(user) {
  return user && user.show_dead_links !== undefined;
}

export function getEdgeStatusFromUser(user) {
  if (!user?.dealer?.edge) {
    return false;
  }
  const status = constants.edgeStatuses.find(
    status => user.dealer[status.prop_name] === true
  );
  return status ? status : false;
}

export function getHasCollapse(item) {
  return item.level === 0 && item.title === "Products";
}

export const getLinkUrlFromResult = result => {
  return result.remote_url ? result.remote_url : result.object_url;
};

export function getMouseLeavesVerticallyHandler(containerRef, cb) {
  return e => {
    const mouseExitY = e.clientY;
    const rect = containerRef.current.getBoundingClientRect();

    // call cb function only when mouse leaves through top or bottom of container
    if (mouseExitY >= rect.y + rect.height || mouseExitY <= rect.y) {
      cb();
    }
  };
}

export function getVisibleChildren(item, user) {
  if (!item || !item.children || !user) {
    return [];
  }
  return item.children.filter(child => shouldShowItemToUser(child, user));
}

export function getShowDeadLinks(user) {
  return user?.show_dead_links;
}

export function getUserInitials(user) {
  if (!user?.fullname) {
    return "";
  }
  const names = user.fullname.split(" ");
  const firstInitial = names[0].charAt(0);
  const lastInitial = names.length > 1 ? names[names.length - 1].charAt(0) : "";
  return firstInitial + lastInitial;
}

export function getWhiteEdgeIconFromUser(user) {
  const status = getEdgeStatusFromUser(user);
  return status ? status.whiteIcon : null;
}

export function hasChildren(item) {
  return item && item.children && item.children.length > 0;
}

export function hasVisibleChildren(item, user) {
  return getVisibleChildren(item, user).length > 0;
}

export function lastChar(str) {
  return str.charAt(str.length - 1);
}

export function setPreventBodyScroll(prevent) {
  if (prevent) {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";
    document.body.style.overflow = "hidden";
    // we must define width on fixed body, otherwise it will take width of content
    // and break margin: auto on screens wider than 2500px
    document.body.style.width = "100vw";
    // document.body.style.overflowY = "scroll";
  } else {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    // document.body.style.overflowY = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
}

export const shouldShowItemToUser = (item, user) => {
  return item.review_state !== "private" || user?.show_dead_links;
};

export function slideBodyWithMenu(slide, ref) {
  const bodySlideClass = "mtt-header-mobile-nav-body-slide";
  const wrapperSlideClass = "mtt-header-mobile-nav-container-open";
  if (slide) {
    requestAnimationFrame(() => {
      if (ref.current) {
        ref.current.classList.add(wrapperSlideClass);
      }
      document.body.classList.add(bodySlideClass);
    });
  } else {
    requestAnimationFrame(() => {
      document.body.classList.remove(bodySlideClass);
      if (ref.current) {
        ref.current.classList.remove(wrapperSlideClass);
      }
    });
  }
}

export const someHaveChildren = items => {
  return items.filter(item => hasChildren(item)).length > 0;
};

export function openNewWindowIfPossible(url) {
  // in case the user has an aggressive pop-up blocker,
  // fall back to changing window url when window.open() returns false
  window.open(url, "_blank") || window.location.assign(url);
}
